import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import {
  HeroSection,
  BillingStepsSection,
  PaymentMethodsSection,
  SmartMeteringSection,
  MonthlyInvoiceSection,
  PortalFeaturesSection,
  BillingMovingSection,
  BillingFAQSection,
  RefundsPolicySection,
  EmergencyCTASection,
} from "../../components";

export function BillingPayment() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Transparent Billing. Easy Payments. Clear Consumption Tracking"
        description="At GASIS, we believe that utility billing should be simple and predictable. Our smart metering system ensures accurate readings every month — and our payment options make settling your bill fast and convenient."
        heroImage={heroImage}
      />
      <BillingStepsSection />
      <PaymentMethodsSection />
      <SmartMeteringSection />
      <MonthlyInvoiceSection />
      <PortalFeaturesSection />
      <BillingMovingSection />
      <BillingFAQSection />
      <RefundsPolicySection />
      <EmergencyCTASection
        title="Need Help with your Bill or Account"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GASIS (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
          <div className="flex items-center gap-2.5">
            <img src={mailIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              help@gasis.ae
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={phoneIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              Support (8 AM – 8 PM)
            </span>
          </div>
          <div className="flex items-center gap-2.5">
            <img src={buildingIcon} alt="" className="w-4 h-4" />
            <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
              Sunday – Thursday (8 AM – 6 PM)
            </span>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default BillingPayment;
